import React from 'react';
import Webcam from "react-webcam";
import { connect } from 'react-redux'
import * as actionCreators from '../../store/Action'
import Visitor_Upload from '../../assets/img/visitor_upload/upload.svg'
import {MDBModalBody, MDBModalHeader} from "mdbreact";
import { Col, Row } from "reactstrap";
import { Button as SementicBtn } from "semantic-ui-react";
import * as actionCreator from "../../store/Action";

class VisitorPhotoUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            screenshot: '',
            defaultimage: true,
            visitorimage: false,
        };
    }

    screenshot = () => {
        let screenshot = this.refs.webcam.getScreenshot();
        this.setState({
            screenshot: screenshot,
            modal: false,
            defaultimage: false,
            visitorimage: true
        });
        this.props.screenshotHandler(screenshot);
    };

    toggle = () => {
    };

    modal = () => {
        this.setState({
            modal: true
        });
    };
    render() {
        const videoConstraints = {
            facingMode: "user"
        };

        let $imagePreview = null;
        if (this.props.screenshot !== '') {

        } else {
            $imagePreview = (
                <div className="previewText"
                    style={this.props.image ? isImage : isNotImage}
                >
                    <img style={this.props.image ? isImageTag : isNotImageTag}
                        src={this.props.image ? this.props.image : Visitor_Upload} />
                </div>);
        }
      // isOpen={true} toggle={this.toggle} size="md" centered={true}
     return (
            <div className="previewComponent">
              {
                this.state.modal ?
                  <div className={"visitor-image-modal"}>
                    <MDBModalHeader className={"title"} toggle={()=>this.setState({modal:false})}>
                      {/*Get Visitor Image*/}
                    </MDBModalHeader>

                    <MDBModalBody style={{ padding: '0px' }}>
                      <Webcam
                        forceScreenshotSourceSize={true}
                        mirrored={true}
                        imageSmoothing={true}
                        screenshotQuality={100}
                        onUserMediaError={() => {
                        }}
                        onUserMedia={() => {
                        }}
                        videoConstraints={videoConstraints}
                        style={{ width: '100%' }}
                        audio={false}
                        screenshotFormat="image/jpeg"
                        ref='webcam'
                      />
                      <br/>

                      <Row>
                        <Col >
                          <SementicBtn className="px-5 search-visitor-btn"
                                       onClick={this.screenshot.bind(this)}
                          >Capture</SementicBtn>
                        </Col>
                      </Row>
                      <br/>
                    </MDBModalBody>
                  </div>
                  : null
              }
                <form
                >
                    <input className="fileInput"
                        type="file"
                        accept="image/png, image/jpeg"
                        style={{
                            display: 'none',
                            cursor: 'pointer',
                            zIndex: '1',
                            position: 'absolute',
                            marginTop: '0%',
                            opacity: '0',
                            width: '200px',
                            height: '150px',
                        }}

                    />
                </form>
                <Row>
                    <Col>
                    <SementicBtn style={{ background: "#cbeecb" }} className="px-5__ live-image-reg-form"
                                       onClick={this.modal}
                          >Live image</SementicBtn>

                    </Col>
                </Row>
            </div>
        )
    }
}

let isImageTag = {
    height: '200px',
    width: '150px',
    objectFit: 'contain'
};

let isNotImageTag = {
    height: '45%',
};


let isImage = {
    width: '200px',
    height: '150px',
    color: 'white',
  // border: '1px #9a9a9a dotted',
  boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.161)',
    cursor: 'pointer'
};
let isNotImage = {
    width: '200px',
    height: '150px',
    color: 'white',
    paddingTop: '30%',
  // border: '1px #9a9a9a dotted',
  boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.161)',
    cursor: 'pointer'
};

const mapStateToProps = (state) => ({
    usr_obj: state.userReducer.user,
    all_available_card: state.reception_SheduleMeetingReducer.all_available_card,
});

const mapDispatchToProps = (dispatch) => {
    return {
        imageUploaderHandler: (image) => dispatch(actionCreators.imageUploaderHandler(image)),
        // spinner handler
        spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
        // all available cards
        receptionAllAvailableCardHandler: (data) => dispatch(actionCreator.receptionAllAvailableCardHandler(data))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(VisitorPhotoUpload);
